import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
} from "react";
import axios from "axios";
import styled from "styled-components";
import Chip from "@mui/material/Chip";
import DataTable from "react-data-table-component";
import useEntitesTable from "./useEntitesTable.js";
import Button from "components/CustomButtons/Button.js";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import AddWallDialog from "./AddWallDialog.js";
import EditWallDialog from "./EditWallDialog";
import UserService from "services/UserService";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { makeStyles, withStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";
import CloseIcon from "@mui/icons-material/Close";
import { zone } from "variables/patrimoine.js";
import { getSite, getFiles, downloadFile } from "services/ConfigServices";
import Edit from "@mui/icons-material/Edit";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { walltype, getObjectFromId } from "variables/lists/patrimoine.js";
import { NotificationManager } from 'react-notifications';

const useStyles = makeStyles(styles);

const styless = (theme) => ({
  root: {
    margin: 0,
    padding: '16px',
  },
  closeButton: {
    position: "absolute",
    right: '8px',
    top: '8px',
    color: '#9e9e9e',
  },
  button: {
    backgroundColor: "",
    bordertopleftradius: 0,
    borderbottomleftradius: 0,
    bordertoprightradius: "5px",
    borderbottomrightradius: "5px",
    height: "34px",
    width: "32px",
    textalign: "center",
    display: "flex",
    alignitems: "center",
    justifycontent: "center",
    "&:hover": {
      cursor: "pointer",
    },
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
});

const DialogTitle = withStyles(styless)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementDataClickable = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
  cursor: pointer;
  text-decoration: underline;
`;




const downloadGED = (fileId, fileName) => async () => {
  axios
    .get(
      downloadFile(fileId),
      {
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      }
    )
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
};

const Walls = (props) => {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const { parameters } = props;
  const {
    gridState,
    materialList,
    refreshTable,
    invalidate,
    handleClose,
  } = useEntitesTable(
    parameters,
    <AddWallDialog
      parameters={parameters}
      closeModal={() => handleClose()}
      refetch={() => refreshTable()}
      deleteCounter={() => handleDeleteCounterChange()}
    />,
    "Nouvelle cloison",
    "Ajout d'une cloison",
    "Liste cloisons"
  );
  const [deleteCounter, setDeleteCounter] = useState(0);
  const [open, setOpen] = useState(false);
  const [prevWallList, setPrevWallList] = useState();
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const [name, setName] = useState("");
  const [clef, setClef] = useState("");
  const [type, setType] = useState("");
  const [materials, setMaterials] = useState("");
  const [length, setLength] = useState("");
  const [width, setWidth] = useState("");
  const [surface, setSurface] = useState("");
  const [thickness, setThickness] = useState("");
  const [thicknessprecision, setThicknessprecision] = useState("");
  const [walldependency, setWalldependency] = useState("");
  const [deperdition, setDeperdition] = useState("");
  const [uponderation, setUponderation] = useState("");
  const [uwall, setUwall] = useState("");
  const [thermicalresistance, setThermicalresistance] = useState("");
  const [deperditionpart, setDeperditionpart] = useState("");
  const [wallorientation, setWallorientation] = useState("");
  const [rooftilt, setRooftilt] = useState("");
  const [performancegrade, setPerformancegrade] = useState("");
  const [performancecomment, setPerformancecomment] = useState("");
  const [dilapidationgrade, setDilapidationgrade] = useState("");
  const [dilapidationcomment, setDilapidationcomment] = useState("");
  const [otherproperties, setOtherproperties] = useState([]);
  const [associatedfiles, setAssociatedfiles] = useState([]);
  const [comments, setComments] = useState("");
  const [description, setDescription] = useState("");

  const handleNameChange = (event) => { setName(event.target.value); };
  const handleClefChange = (event) => { setClef(event.target.value); };
  const handleTypeChange = (event) => { setType(event.target.value); };
  const handleMaterialsChange = (newvalue) => {
    let listtosave = [];
    let listtosaveshort = [];
    let newvalueuuid = [];
    let sumthermicalresistance = 0.0;
    for (let i = 0; i < newvalue.length; i++) {
      newvalueuuid.push(newvalue[i].uuid);
    }
    listtosave = materialList.filter((material) =>
      newvalueuuid.includes(material.uuid)
    );
    listtosave.forEach((element) => {
      listtosaveshort.push({ uuid: element.uuid, name: element.name });
      if (element.thermicalresistance) {
        sumthermicalresistance = sumthermicalresistance + element.thermicalresistance;
      }
    });
    let uwall = 0;
    if (sumthermicalresistance > 0) {
      uwall = Math.round((1 / sumthermicalresistance) * 100) / 100;
    }
    setUwall(uwall);
    setThermicalresistance(sumthermicalresistance);
    setMaterials(listtosaveshort);
  };
  const handleLengthChange = (event) => { setLength(event.target.value); };
  const handleWidthChange = (event) => { setWidth(event.target.value); };
  const handleSurfaceChange = (event) => { setSurface(event.target.value); };
  const handleThicknessChange = (event) => { setThickness(event.target.value); };
  const handleThicknessprecisionChange = (event) => { setThicknessprecision(event.target.value); };
  const handleWalldependencyChange = (event) => { setWalldependency(event.target.value); };
  const handleDeperditionChange = (event) => { setDeperdition(event.target.value); };
  const handleUponderationChange = (event) => { setUponderation(event.target.value); };
  const handleUwallChange = (event) => {
    let uwall = event.target.value;
    let rtherm = 0;
    if (uwall > 0) {
      rtherm = Math.round((1 / uwall) * 100) / 100;
    }
    setUwall(uwall);
    setThermicalresistance(rtherm);
  };
  const handleThermicalresistanceChange = (event) => { setThermicalresistance(event.target.value); };
  const handleDeperditionpartChange = (event) => { setDeperditionpart(event.target.value); };
  const handleWallorientationChange = (event) => { setWallorientation(event.target.value); };
  const handleRooftiltChange = (event) => { setRooftilt(event.target.value); };
  const handlePerformancegradeChange = (event) => { setPerformancegrade(event.target.value); };
  const handlePerformancecommentChange = (event) => { setPerformancecomment(event.target.value); };
  const handleDilapidationgradeChange = (event) => { setDilapidationgrade(event.target.value); };
  const handleDilapidationcommentChange = (event) => { setDilapidationcomment(event.target.value); };
  const handleOtherpropertiesChange = (newvalue) => { setOtherproperties(newvalue); };
  const handleAssociatedfilesChange = (newvalue) => { setAssociatedfiles(newvalue); };
  const handleCommentsChange = (event) => { setComments(event.target.value); };
  const handleDescriptionChange = (event) => { setDescription(event.target.value); };

  const updateState = useCallback((state) => console.log(state));
  const handleDeleteCounterChange = (e) => {
    setDeleteCounter((prevCounter) => prevCounter + 1);
  };

  const classes = useStyles();

  let dataWalls = gridState.data;

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
  };

  const columns = [
    {
      name: zone.structure.walls.walls.name,
      selector: row => row.name,
      sortable: true,
    },
    {
      name: zone.structure.walls.walls.key,
      selector: row => row.clef,
      sortable: true,
    },
    {
      name: zone.structure.walls.walls.type,
      selector: row => row.type,
      sortable: true,
    },
    // {
    //   name: batiment.structure.walls.walls.type,
    //   selector: row => row.type,
    //   sortable: true,
    //   cell: (row) => (
    //     <>
    //       {getObjectFromId(row.type, walltype)?.name || ""}
    //     </>
    //   )
    // },
    realestateupdate ?
      {
        name: "Actions",
        sortable: true,
        width: "8rem",
        // eslint-disable-next-line react/display-name
        cell: (row) => (
          <>
            <div className="actions-right">
              <Button
                color={"success"}
                className={classes.actionButton}
                onClick={editWall(row)}
              >
                <Edit className={classes.icon} />
              </Button>
              <CustomDeleteButton
                deleteTitle={"Suppression de la cloison"}
                deleteSubTitle={
                  "Êtes-vous sûr de vouloir supprimer la cloison?"
                }
                handleSupprimer={deleteWall(row)}
              />
            </div>
          </>
        ),
      } : {},
  ];

  const ExpandableComponent = props => {
    const { data } = props;
    return (
      <Container>
        <ExpandableContainer>
          {data.length ?
            <ExpandableElement>
              <ElementTitle>{zone.structure.walls.walls.length} : </ElementTitle>
              <ElementData>{data.length}</ElementData>
            </ExpandableElement> : <></>
          }
          {data.width ?
            <ExpandableElement>
              <ElementTitle>{zone.structure.walls.walls.width} : </ElementTitle>
              <ElementData>{data.width}</ElementData>
            </ExpandableElement> : <></>
          }
          {data.surface ?
            <ExpandableElement>
              <ElementTitle>{zone.structure.walls.walls.surface} : </ElementTitle>
              <ElementData>{data.surface}</ElementData>
            </ExpandableElement> : <></>
          }
          {data.thickness ?
            <ExpandableElement>
              <ElementTitle>{zone.structure.walls.walls.thickness} : </ElementTitle>
              <ElementData>{data.thickness}</ElementData>
            </ExpandableElement> : <></>
          }
          {data.walldependency && prevWallList ?
            <ExpandableElement>
              <ElementTitle>{zone.structure.walls.walls.walldependency} : </ElementTitle>
              {prevWallList.map((wall, index) => (
                wall.uuid === data.walldependency ? <ElementData>{wall.name}</ElementData> : <></>
              ))}
            </ExpandableElement> : <></>
          }
          {data.materials && Array.isArray(data.materials)?
            <ExpandableElement>
              <ElementTitle>{zone.structure.walls.walls.materials} : </ElementTitle>
              {data.materials.map((mater, index) => (
                <ElementData>"{mater.name}"</ElementData>
              ))}
            </ExpandableElement> : <></>
          }
          {data.deperdition ?
            <ExpandableElement>
              <ElementTitle>{zone.structure.walls.walls.deperdition} : </ElementTitle>
              <ElementData>{data.deperdition}</ElementData>
            </ExpandableElement> : <></>
          }
          {data.uponderation ?
            <ExpandableElement>
              <ElementTitle>{zone.structure.walls.walls.uponderation} : </ElementTitle>
              <ElementData>{data.uponderation}</ElementData>
            </ExpandableElement> : <></>
          }
          {data.thermicalresistance ?
            <ExpandableElement>
              <ElementTitle>{zone.structure.walls.walls.thermicalresistance} : </ElementTitle>
              <ElementData>{data.thermicalresistance}</ElementData>
            </ExpandableElement> : <></>
          }
          {data.uwall ?
            <ExpandableElement>
              <ElementTitle>{zone.structure.walls.walls.uwall} : </ElementTitle>
              <ElementData>{data.uwall}</ElementData>
            </ExpandableElement> : <></>
          }
          {data.deperditionpart ?
            <ExpandableElement>
              <ElementTitle>{zone.structure.walls.walls.deperditionpart} : </ElementTitle>
              <ElementData>{data.deperditionpart}</ElementData>
            </ExpandableElement> : <></>
          }
          {data.wallorientation ?
            <ExpandableElement>
              <ElementTitle>{zone.structure.walls.walls.wallorientation} : </ElementTitle>
              <ElementData>{data.wallorientation}</ElementData>
            </ExpandableElement> : <></>
          }
          {data.rooftilt ?
            <ExpandableElement>
              <ElementTitle>{zone.structure.walls.walls.rooftilt} : </ElementTitle>
              <ElementData>{data.rooftilt}</ElementData>
            </ExpandableElement> : <></>
          }
          {data.performancegrade ?
            <ExpandableElement>
              <ElementTitle>{zone.structure.walls.walls.performancegrade} : </ElementTitle>
              <ElementData>{data.performancegrade}</ElementData>
            </ExpandableElement> : <></>
          }
          {data.performancecomment ?
            <ExpandableElement>
              <ElementTitle>{zone.structure.walls.walls.performancecomment} : </ElementTitle>
              <ElementData>{data.performancecomment}</ElementData>
            </ExpandableElement> : <></>
          }
          {data.dilapidationgrade ?
            <ExpandableElement>
              <ElementTitle>{zone.structure.walls.walls.dilapidationgrade} : </ElementTitle>
              <ElementData>{data.dilapidationgrade}</ElementData>
            </ExpandableElement> : <></>
          }
          {data.dilapidationcomment ?
            <ExpandableElement>
              <ElementTitle>{zone.structure.walls.walls.dilapidationcomment} : </ElementTitle>
              <ElementData>{data.dilapidationcomment}</ElementData>
            </ExpandableElement> : <></>
          }
          {data.otherproperties ?
            <ExpandableElement>
              <ElementTitle>{zone.structure.walls.walls.otherproperties} : </ElementTitle>
              {data.otherproperties.map((prop, index) => (
                <ElementData>"{prop}"</ElementData>
              ))}
            </ExpandableElement> : <></>
          }
          {data.associatedfiles  && typeof data.associatedfiles === 'array' ? 
            <ExpandableElement>
              <ElementTitle>{zone.structure.walls.walls.associatedfiles} : </ElementTitle>
              {data.associatedfiles.map((file, index) => (
                <ElementDataClickable onClick={downloadGED(file.fileId, file.fileName)}>
                  {file.fileName}</ElementDataClickable>
              ))}
            </ExpandableElement> : <></>
          }
          {data.comments ?
            <ExpandableElement>
              <ElementTitle>{zone.structure.walls.walls.comments} : </ElementTitle>
              <ElementData>{data.comments}</ElementData>
            </ExpandableElement> : <></>
          }
          {data.description ?
            <ExpandableElement>
              <ElementTitle>{zone.structure.walls.walls.description} : </ElementTitle>
              <ElementData>{data.description}</ElementData>
            </ExpandableElement> : <></>
          }
        </ExpandableContainer>
      </Container>
    );
  };

  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "structure.walls.walls"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setPrevWallList(res.data.detail?.structure?.walls?.walls || []);
      });

  }, [deleteCounter]);


  const [idSelected, setIdSelected] = useState();

  const editWall = (row) => async () => {
    let obj = dataWalls.find((o) => o.uuid === row.uuid);
    handleClickOpen();

    setIdSelected(obj.uuid);
    setName(obj?.name);
    setClef(obj?.clef);
    setType(obj?.type);
    setMaterials(obj?.materials);
    setLength(obj?.length);
    setWidth(obj?.width);
    setSurface(obj?.surface);
    setThickness(obj?.thickness);
    setThicknessprecision(obj?.thicknessprecision);
    setWalldependency(obj?.walldependency);
    setDeperdition(obj?.deperdition);
    setUponderation(obj?.uponderation);
    setUwall(obj?.uwall);
    setThermicalresistance(obj?.thermicalresistance);
    setDeperditionpart(obj?.deperditionpart);
    setWallorientation(obj?.wallorientation);
    setRooftilt(obj?.rooftilt);
    setComments(obj?.comments);
    setPerformancegrade(obj?.performancegrade);
    setPerformancecomment(obj?.performancecomment);
    setDilapidationgrade(obj?.dilapidationgrade);
    setDilapidationcomment(obj?.dilapidationcomment);
    setOtherproperties(obj?.otherproperties);
    setAssociatedfiles(obj?.associatedfiles);
    setComments(obj?.comments);
    setDescription(obj?.description);
  };

  const deleteWall = (row) => async () => {
    let obj = dataWalls.find((o) => o.uuid === row.uuid);
    const indexToReplace = dataWalls.findIndex((x) => x.uuid === obj.uuid);
    const walllist = prevWallList;
    walllist.splice(indexToReplace, 1);
    axios
      .put(
        getSite(chartIdGroup, "structure.walls.walls"),
        walllist,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Cloison supprimée");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
        refreshTable();
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  return (
    <>
      <div
        style={{
          marginTop: "-1.8rem ",
          paddingTop: "0.5rem",
          //borderTop: "solid 1.2px rgba(0, 0, 0, 0.15)",
        }}
      >
        <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
          columns={columns}
          persistTableHead
          pagination
          noHeader={true}
          subHeader
          onSelectedRowsChange={updateState}
          expandOnRowClicked
          expandableRows
          expandableRowDisabled={(row) => row.disabled}
          expandableRowsComponent={ ExpandableComponent }
          progressPending={gridState.loading}
          progressComponent={<LinearProgress />}
          {...gridState}
        ></DataTable>
        <Dialog
          onClose={handleEditClose}
          aria-labelledby="edituser-dialog-title"
          fullWidth="true"
          maxWidth="sm"
          open={open}
        >
          <DialogTitle id="customized-dialog-title" onClose={handleEditClose}>
            Modifier la cloison
          </DialogTitle>
          <DialogContent dividers>
            <EditWallDialog
              parameters={parameters}
              closeModal={handleEditClose}
              refetch={refreshTable}
              idSelected={idSelected}
              prevWallList={prevWallList}
              materialList={materialList}
              name={name}
              clef={clef}
              type={type}
              materials={materials}
              length={length}
              width={width}
              surface={surface}
              thickness={thickness}
              thicknessprecision={thicknessprecision}
              walldependency={walldependency}
              deperdition={deperdition}
              uponderation={uponderation}
              uwall={uwall}
              thermicalresistance={thermicalresistance}
              deperditionpart={deperditionpart}
              wallorientation={wallorientation}
              rooftilt={rooftilt}
              performancegrade={performancegrade}
              performancecomment={performancecomment}
              dilapidationgrade={dilapidationgrade}
              dilapidationcomment={dilapidationcomment}
              otherproperties={otherproperties}
              associatedfiles={associatedfiles}
              comments={comments}
              description={description}
              handleNameChange={handleNameChange}
              handleClefChange={handleClefChange}
              handleTypeChange={handleTypeChange}
              handleMaterialsChange={handleMaterialsChange}
              handleLengthChange={handleLengthChange}
              handleWidthChange={handleWidthChange}
              handleSurfaceChange={handleSurfaceChange}
              handleThicknessChange={handleThicknessChange}
              handleThicknessprecisionChange={handleThicknessprecisionChange}
              handleWalldependencyChange={handleWalldependencyChange}
              handleDeperditionChange={handleDeperditionChange}
              handleUponderationChange={handleUponderationChange}
              handleUwallChange={handleUwallChange}
              handleThermicalresistanceChange={handleThermicalresistanceChange}
              handleDeperditionpartChange={handleDeperditionpartChange}
              handleWallorientationChange={handleWallorientationChange}
              handleRooftiltChange={handleRooftiltChange}
              handlePerformancegradeChange={handlePerformancegradeChange}
              handlePerformancecommentChange={handlePerformancecommentChange}
              handleDilapidationgradeChange={handleDilapidationgradeChange}
              handleDilapidationcommentChange={handleDilapidationcommentChange}
              handleOtherpropertiesChange={handleOtherpropertiesChange}
              handleAssociatedfilesChange={handleAssociatedfilesChange}
              handleCommentsChange={handleCommentsChange}
              handleDescriptionChange={handleDescriptionChange}
            />
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default Walls;
